import tw from 'clsx';
import React from 'react';

import SearchIcon from '@public/new-icons/icon/icon_search.svg';

type Props = {
  disabled?: boolean;
  value: string;
  label?: string;
  placeholder: string;
  miniMode?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
};

export function SearchInput({
  disabled = false,

  value,
  label = '',
  placeholder,
  onChange,
  miniMode = false,
  onKeyDown,
  onBlur,
}: Props) {
  return (
    <label
      htmlFor={label}
      className={tw(
        `flex items-center gap-1 rounded-corner-s border border-solid border-base p-s__sp focus:border-focus focus:outline-none disabled:border-light`,
        {
          'h-[40px] w-full lg:max-w-[240px] lg:p-s': !miniMode,
          'h-[36px] w-[224px]': miniMode,
          'border-light': disabled,
        },
      )}
    >
      {label}
      <div className='h-[20px] w-[20px]'>
        <SearchIcon className={`${disabled ? 'text-disabled' : 'text-object-tertiary'}`} />
      </div>
      <input
        value={value}
        onChange={onChange}
        disabled={disabled}
        type='text'
        id={label}
        placeholder={placeholder}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        className='h-full flex-1 items-center rounded-corner-s bg-white text-label-medium text-regular transition placeholder:text-placeholder focus:outline-none disabled:text-disabled disabled:placeholder:text-disabled'
      />
    </label>
  );
}
